import { Link } from 'react-router-dom';
import { articles, categories, getArticlesByCategory } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

const featuredSlugs = [
  'hanxiucao-de-qiyuan-yu-fenbu',
  'ruhe-cong-zhongzi-kaishi-zhongzhi',
  'yepian-yundong-de-aomi',
  'jiaoshui-yu-guangzhao-guanli',
  'xuexi-yu-jiyi-nengli',
  'bingchonghai-fangzhi-shouce',
];

export default function FeaturedArticles() {
  const featuredArticles = featuredSlugs
    .map((slug) => articles.find((a) => a.slug === slug))
    .filter(Boolean) as typeof articles;

  const getCategoryName = (categorySlug: string) => {
    const cat = categories.find((c) => c.slug === categorySlug);
    return cat ? cat.name : '';
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              从入门到精通，手把手教你养好害羞草
            </p>
          </div>
          <Link
            to="/category/shengzhang-xixing"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              imageUrl={article.imageUrl}
              date={article.date}
              readTime={article.readTime}
              categoryName={getCategoryName(article.category)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}